import { SystemBannerContainer } from '@tankef/ui';

import { useNotificationsContext } from '../notifications-context';

import { useActiveNotices, useDismissNotice } from '@/shared/session/api';

/**
 * App-shell level alerts: critical system issues (e.g. SPEI down) + dismissable
 * notices. Rendered at the very top of the layout, above the sidebar/main row,
 * so both columns start aligned.
 */
export function GlobalAlerts() {
  const notices = useActiveNotices();
  const dismissNotice = useDismissNotice();
  const { systemAlert, dismissSystemAlert } = useNotificationsContext();

  return (
    <>
      {systemAlert && (
        <div
          className={`w-full px-4 py-3 text-center text-white font-medium ${
            systemAlert.severity === 'critical'
              ? 'bg-error-600'
              : systemAlert.severity === 'warning'
                ? 'bg-warning-600'
                : 'bg-info-600'
          }`}
        >
          <div className="mx-auto flex max-w-7xl items-center justify-between">
            <span>{systemAlert.message}</span>
            <button
              type="button"
              onClick={() => dismissSystemAlert()}
              className="ml-4 transition-opacity hover:opacity-80"
              aria-label="Cerrar alerta"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <SystemBannerContainer notices={notices} onDismiss={dismissNotice} />
    </>
  );
}
